import styles from "styles/About.module.scss";

const About = () => {
    return (
        <section className={styles.about}>
            <div className={styles.cardContainer}>
                <div className={styles.card}>
                    <h2 className={styles.cardTitle}>Quienes Somos</h2>
                    <p className={styles.cardContent}>
                        Muscle Factory fue fundado con la misión de empoderar a las personas a
                        transformar sus vidas a través del fitness y la salud. Nos destacamos por
                        ofrecer una experiencia de gimnasio de primer nivel y productos de alta
                        calidad que complementan tu camino hacia un mejor bienestar.
                    </p>
                    <p className={styles.cardContent}>
                        Nuestra pasión es el progreso, y nuestra dedicación al servicio al cliente
                        garantiza que cada miembro alcance sus metas de forma efectiva y segura.
                    </p>
                </div>

                <div className={styles.card}>
                    <h2 className={styles.cardTitle}>Nuestra Visión</h2>
                    <p className={styles.cardContent}>
                        En Muscle Factory, aspiramos a ser un referente en la industria del fitness,
                        reconocidos por nuestra innovación, excelencia y compromiso con la sostenibilidad.
                    </p>
                    <p className={styles.cardContent}>
                        Buscamos más que solo ayudar a nuestros clientes a alcanzar sus objetivos:
                        fomentamos una comunidad inclusiva donde la motivación y el apoyo mutuo son
                        la clave del éxito.
                    </p>
                </div>

                <div className={styles.card}>
                    <h2 className={styles.cardTitle}>Nuestros Valores</h2>
                    <p className={styles.cardContent}>
                        En Muscle Factory, nuestros valores son los cimientos de nuestra identidad.
                        La calidad es la esencia de nuestros productos y servicios, y la satisfacción
                        del cliente es nuestra máxima prioridad.
                    </p>
                    <p className={styles.cardContent}>
                        La integridad guía cada decisión que tomamos, y la mejora continua asegura
                        que siempre ofrezcamos lo mejor a nuestros clientes. Creemos en un entorno
                        que promueve la superación personal y el bienestar general.
                    </p>
                </div>
            </div>

            <div className={styles.contactContainer}>
                <div className={styles.contactCard}>
                    <h2 className={styles.contactTitle}>Contáctanos</h2>
                    <p>Teléfono: <a href="tel:+50685975180">+506 8597-5180</a></p>
                    <div className={styles.socialLinks}>
                        <a href="https://www.facebook.com/musclefactorycr" target="_blank" rel="noopener noreferrer">Facebook</a>
                        <a href="https://www.instagram.com/muscle_factory_gym_cr/" target="_blank" rel="noopener noreferrer">Instagram</a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
